module.exports = __webpack_public_path__ + "img/banner-contact.b7437f23.jpg";